export enum QuerySortDirectionsEnum {
	asc = 'asc',
	desc = 'desc'
}
